export default __webpack_public_path__ + "static/nazakids-beacb26c66fa9e6e236dd490c6904243.png";